import React from 'react'

import { Highlight } from 'react-instantsearch/dom'
import { ListItem } from 'material-ui/List'
import { connect } from 'react-redux'
import * as firebase from 'firebase'
import moment from 'moment'

class SearchRow extends React.PureComponent {

  constructor(props){
    super(props)
    this.state = {
      jobInfo: {}
    }
    this.listener = this.onUpdate.bind(this)
  }

  componentDidMount() {
    this.initLoaders(this.props.eventId, this.props.dateStr)
  }

  componentWillUnmount() {
    this.detachLoaders(this.props.eventId, this.props.dateStr)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.dateStr !== this.props.dateStr ||
      nextProps.eventId !== this.props.eventId) {
      this.detachLoaders(this.props.eventId, this.props.dateStr)
      this.initLoaders(nextProps.eventId, nextProps.dateStr)
    }
  }

  initLoaders(eventId, dateStr) {
    // Start querying and listening for changes
    const dbPath = `events/${eventId}/commonInfo`
    firebase.database().ref(dbPath).on('value', this.listener)
  }

  detachLoaders(eventId, dateStr) {
    const dbPath = `events/${eventId}/commonInfo`
    firebase.database().ref(dbPath).off('value', this.listener)
  }

  onUpdate(snapshot) {
    let value = snapshot.val()
    this.setState({
      jobInfo: value
    })
  }

  render() {
    let rowColor = 'rgba(155, 155, 155, 0.25)'
    const today = moment().format('YYYY-MM-DD')
    const todayTimeStamp = new Date(today).getTime()
    const resultTimeStamp = new Date(this.props.hit.dateStr).getTime()
    const workersField = []

    if (resultTimeStamp > todayTimeStamp){
      //future rows
      rowColor = '#dbefff'
    } else if (resultTimeStamp < todayTimeStamp){
      //past rows
      rowColor = 'rgba(239, 173, 39, 0.1)'
    }

    if (this.props.hit.workers
        && this.props.hit.workers.length){
      this.props.hit.workers.forEach((worker, index) => {
        const hightlightAttr = this.props.hit._highlightResult.workers[index] || {}
        const workerHit = {
          worker: worker,
          _highlightResult: {worker: hightlightAttr}
        }
        workersField.push(<div key={index} style={{flex: 1}}> <Highlight attributeName="worker" hit={workerHit} /> </div>)
      })
    }

    return(
      <div style={{backgroundColor: rowColor}}>
        <ListItem
          innerDivStyle={{
            display: 'flex',flexDirection: 'row', paddingLeft: 0, justifyContent: 'space-between'
          }}
          onClick={() => {
            this.props.dispatch({
              type: 'UI_DIALOG',
              label: 'JOB_SCREEN',
              value: {
                jobInfo: this.state.jobInfo,
                dateStr: this.props.dateStr
              }
            })
          }}>
          <div style={{width: 200, fontSize: 14, justifyContent:'flex-start'}} className="hit-name">
            {this.props.hit.dateStr}
          </div>
          <div style={{width: 200, fontSize: 14, justifyContent:'flex-start'}} className="hit-name">
            <Highlight attributeName="displayName" hit={this.props.hit} />
          </div>
          <div style={{width: 200, fontSize: 14, display:'flex', flexDirection: 'column', justifyContent:'flex-start'}} className="hit-name">
            <Highlight attributeName="contactInfo.name" hit={this.props.hit} />
            <Highlight attributeName="contactInfo.email" hit={this.props.hit} />
            <Highlight attributeName="contactInfo.phoneNumber" hit={this.props.hit} />
          </div>
          <div style={{width: 200, fontSize: 14, justifyContent:'flex-start'}} className="hit-name">
            <Highlight attributeName="address" hit={this.props.hit} />
          </div>
          <div style={{width: 200, fontSize: 14, flexDirection: 'column', justifyContent:'flex-start'}} className="hit-name">
            {workersField}
          </div>
        </ListItem>
      </div>
    )
  }

}

export default connect()(SearchRow)



// WEBPACK FOOTER //
// ./src/schedule/search/SearchRow.js